<div class="modal-container">
  <div class="modal-header">
    <div>
      <h2 class="modal-title">Enviar E-mail</h2>
      <p class="modal-subtitle">
        Envie um e-mail para o contato do projeto Condomínio Vista Mar
      </p>
    </div>
    <button class="btn-close" (click)="fecharModal()">&times;</button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <label for="template">Selecione um template</label>
      <div class="template-select-row">
        <select id="template" class="form-control">
          <option value="" disabled selected>Selecione um template</option>
          <!-- opções dinâmicas -->
        </select>
        <button class="btn btn-secondary">Gerar com IA</button>
      </div>
    </div>

    <div class="form-row">
      <label for="destinatario">Destinatário</label>
      <select id="destinatario" class="form-control">
        <option value="" disabled selected>Selecione um e-mail</option>
        <!-- opções dinâmicas -->
      </select>
    </div>

    <div class="form-row">
      <label for="assunto">Assunto</label>
      <input
        id="assunto"
        type="text"
        class="form-control"
        placeholder="{responsavel}"
      />
    </div>

  <div class="form-row">
  <label for="conteudo">Conteúdo</label>
  <quill-editor
    [(ngModel)]="conteudoEmail"
    [styles]="{height: '200px'}"
    [placeholder]="'Digite o conteúdo do e-mail'"
    theme="snow"
  ></quill-editor>
</div>

  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="fecharModal()">Cancelar</button>
    <button class="btn btn-primary">Salvar Template</button>
    <button class="btn btn-primary">Enviar E-mail</button>
  </div>
</div>
